import React from 'react';
import PropTypes from 'prop-types';
import {useHistory} from 'react-router-dom';

import {currentResource} from '../../../util/utils';
import {tablePaginationSizeOptions} from '../../../util/uiconstants';

import columns from './columns';

import CustomTable from '../../CoreWrappers/CustomTable';

const ReconciliationsTable = ({items = null}) => {
	const history = useHistory();

	if (!items) return false;

	const labels = currentResource.reconciliationsTableLabels;

	const handleSelectComponent = (groupComponentId) => {
		const {componentId, primaryEngagementId} = items?.find((m) => m.componentId === groupComponentId);
		history.push({
			...history.location,
			search: `${history.location.search}&componentId=${componentId}&primaryEngagementId=${primaryEngagementId}`
		});
	};

	const props = {
		id: 'reconciliationsTable',
		data: items,
		columns: columns(labels.columns),
		labels: {
			emptyMessage: labels.unselectedEntities,
			show: labels.show
		},
		headerMultiline: 2,
		pagination: true,
		paginationOptions: tablePaginationSizeOptions,
		defaultColumnSort: 'component',
		headerHeightAuto: true,
		enableBodyScroll: true,
		onRowClick: ({componentId}) => handleSelectComponent(componentId)
	};

	return <CustomTable {...props} />;
};

ReconciliationsTable.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
			component: PropTypes.string.isRequired
		})
	)
};

export default ReconciliationsTable;
